// extracted by mini-css-extract-plugin
export var labelWrapper = "_mb-0";